import { render } from "./CoverageStep3.vue?vue&type=template&id=7e0e2e1a&ts=true"
import script from "./CoverageStep3.vue?vue&type=script&lang=ts"
export * from "./CoverageStep3.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__